module.exports = __webpack_public_path__ + "assets/zhongxindongtaifabu.5e32fb26.svg";